export default __webpack_public_path__ + "static/media/new-logo-cmtech.e9bc8d26.png";